// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.homeBorder {
  border: 1px solid #ececec;
  border-radius: 20px;
  box-shadow: 0px 4px 6px 0px rgba(151, 151, 151, 0.04);
  padding: 20px;
  height: 114px;
  width: 90%;
}

.iconSpacing .MuiButtonBase-root.MuiIconButton-root {
  padding: 0px;
}`, "",{"version":3,"sources":["webpack://./src/components/pages/Home/home.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,qDAAqD;EACrD,aAAa;EACb,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,YAAY;AACd","sourcesContent":[".homeBorder {\n  border: 1px solid #ececec;\n  border-radius: 20px;\n  box-shadow: 0px 4px 6px 0px rgba(151, 151, 151, 0.04);\n  padding: 20px;\n  height: 114px;\n  width: 90%;\n}\n\n.iconSpacing .MuiButtonBase-root.MuiIconButton-root {\n  padding: 0px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
